import { FormatStrikethroughVariantIcon } from './FormatStrikethroughVariantIcon';

/**
 * author: Google
 * id CB728339-FA66-440F-9E88-8A6FFE827EA1
 * name format-strikethrough-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-strikethrough-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const StrikethroughSIcon = FormatStrikethroughVariantIcon;
export default StrikethroughSIcon